import React from 'react'
import { Show } from '@chakra-ui/react'

export const Mobile = ({ children }: { children: React.ReactNode }) => <Show below="lg">{children}</Show>
export const Desktop = ({ children }: { children: React.ReactNode }) => <Show above="lg">{children}</Show>
